// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XComponent_XComponent__FKTFC {
  margin-left: var(--margin-left);
  margin-right: var(--margin-right);
  margin-top: var(--margin-top);
  margin-bottom: var(--margin-bottom);
}`, "",{"version":3,"sources":["webpack://./src/X/components/commons/XComponent.module.scss"],"names":[],"mappings":"AAAA;EACI,+BAAA;EACA,iCAAA;EACA,6BAAA;EACA,mCAAA;AACJ","sourcesContent":[".XComponent {\r\n    margin-left: var(--margin-left);\r\n    margin-right: var(--margin-right);\r\n    margin-top: var(--margin-top);\r\n    margin-bottom: var(--margin-bottom);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"XComponent": `XComponent_XComponent__FKTFC`
};
export default ___CSS_LOADER_EXPORT___;
